import { useEffect, useState } from "react";
import DataContext from "./data-context";
import useCheckAvailableServices from "../Hooks/use-check-available-services";
import { setSelectionRange } from "@testing-library/user-event/dist/utils";

// Initial values for resetting state
const initialAdditionalOptions = [
    { name: "MojaTV", value: 0 },
    { name: "Telefon", value: 0 },
];

const initialState = {
    error: undefined,
    loading: undefined,
    formSent: false,
    location: undefined,
    serviceType: ["Privatni"],
    additionalOptions: initialAdditionalOptions,
    selectedService: undefined,
    selectedTv: 1,
    selectedPhone: 1,
    formSubmitted: false,
    selectedAttibutes: [],
    inHelp: {
        title: "",
        description: "",
        questions: [],
        active: false,
        quickTip: false,
    },
    isSatellite: false,
};

const privateQuestions = [
    {
        id: 0,
        name: "Pregledavanje web stranica",
        active: false,
    },
    {
        id: 1,
        name: "Čitanje e-pošte",
        active: false,
    },
    {
        id: 2,
        name: "Gledanje videa visoke kvalitete",
        active: false,
    },
    {
        id: 3,
        name: "Igranje online igrica",
        active: false,
    },

    {
        id: 4,
        name: "Više od 5 uređaja biti povezani na internet istovremeno",
        active: false,
    },
    {
        id: 5,
        name: "Rad na daljinu/videokonferencije",
        active: false,
    },
    {
        id: 6,
        name: "Preuzimanje velikih datoteka (npr. igre, filmove)",
        active: false,
    },
    {
        id: 7,
        name: "Više simultanih korisnika",
        active: false,
    },
    {
        id: 8,
        name: "Gledanje IPTV visoke razlučivosti",
        active: false,
    },
    {
        id: 9,
        name: "Korištenje pametnih uređaje u svom domu (npr. pametne svjetiljke, termostate)",
        active: false,
    },
    {
        id: 10,
        name: "Mogućnost igranja u oblaku",
        active: false,
    },
    {
        id: 11,
        name: "Wi-Fi pokrivenost za objekt veći od 60 m²",
        active: false,
    },
    {
        id: 12,
        name: "Wi-Fi pokrivenost vanjskih prostora, kao što su terase ili dvorišta",
        active: false,
    },
    {
        id: 13,
        name: "Wi-Fi pokrivenost za bazen ili vanjski rekreacijski prostor",
        active: false,
    },
    {
        id: 14,
        name: "Imate li višekatnicu gdje je potrebna Wi-Fi pokrivenost na svakom katu?",
        active: false,
    },
    {
        id: 15,
        name: "Potreba za dodatne Wi-Fi pristupne točke kako biste osigurali dobru pokrivenost u svim dijelovima objekta",
        active: false,
    },
];

const bussinesQuestions = [
    {
        id: 0,
        name: "Rad na daljinu i videokonferencije?",
        active: false,
    },
    {
        id: 1,
        name: "Korištenje aplikacija koje zahtijevaju visoke brzine interneta",
        active: false,
    },
    {
        id: 2,
        name: "Više od 10 uređaja će biti povezani na internet istovremeno",
        active: false,
    },
    {
        id: 3,
        name: "Korištenje usluga cloud storage-a ili online backup-a",
        active: false,
    },
    {
        id: 4,
        name: "Više simultanih korisnika?",
        active: false,
    },
    {
        id: 5,
        name: "Wi-Fi pokrivenost za objekt veći od 60 m²",
        active: false,
    },
    {
        id: 6,
        name: "Wi-Fi pokrivenost vanjskih prostora, kao što su terase ili dvorišta",
        active: false,
    },
    {
        id: 7,
        name: "Wi-Fi pokrivenost za bazen ili vanjski rekreacijski prostor",
        active: false,
    },
    {
        id: 8,
        name: "Imate li višekatnicu gdje je potrebna Wi-Fi pokrivenost na svakom katu?",
        active: false,
    },
    {
        id: 9,
        name: "Potreba za dodatne Wi-Fi pristupne točke kako biste osigurali dobru pokrivenost u svim dijelovima objekta",
        active: false,
    },
];

const seasonalQuestions = [
    {
        id: 0,
        name: "Pružanje Wi-Fi usluge gostima",
        active: false,
    },
    {
        id: 1,
        name: "Upravljanje online rezervacijama i platformama",
        active: false,
    },
    {
        id: 2,
        name: "Video nadzor ili sigurnosni sustavi koji zahtjevaju stalnu internetsku vezu",
        active: false,
    },
    {
        id: 3,
        name: "Pružanje streaming usluga gostima",
        active: false,
    },
    {
        id: 4,
        name: "Upload fotografija i opisa objekta",
        active: false,
    },
    {
        id: 5,
        name: "Wi-Fi pokrivenost za objekt veći od 60 m²",
        active: false,
    },
    {
        id: 6,
        name: "Wi-Fi pokrivenost vanjskih prostora, kao što su terase ili dvorišta",
        active: false,
    },
    {
        id: 7,
        name: "Wi-Fi pokrivenost za bazen ili vanjski rekreacijski prostor",
        active: false,
    },
    {
        id: 8,
        name: "Imate li višekatnicu gdje je potrebna Wi-Fi pokrivenost na svakom katu?",
        active: false,
    },
    {
        id: 9,
        name: "Potreba za dodatne Wi-Fi pristupne točke kako biste osigurali dobru pokrivenost u svim dijelovima objekta",
        active: false,
    },
];

const DataProvider = ({ children }) => {
    const [processIndex, setProcessIndex] = useState("availability_check");
    const [error, setError] = useState();
    const [loading, setLoading] = useState();
    const [formSent, setFormSent] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isSatellite, setIsSatellite] = useState(false);
    const [triggerInputHouseNumber, setTriggerInputHouseNumber] =
        useState(false);

    /* Availability Check */
    const [location, setLocation] = useState(undefined);
    const [availableServices, checkAvailability, availabilityLodaing] =
        useCheckAvailableServices();

    /* User Type */
    const [serviceType, setServiceType] = useState(["Privatni"]);

    /* Additional Options */
    const [additionalOptions, setAdditionalOptions] = useState([
        { name: "MojaTV", value: 0 },
        { name: "Telefon", value: 0 },
    ]);

    const [selectedAttributes, setSelectedAttributes] = useState([]);
    const [sortedServiceFeatures, setSortedServiceFeatures] = useState([]);

    useEffect(() => {
        const cookies = document.cookie.split("; ");
        let addressCookie = cookies.find((row) =>
            row.startsWith("address" + "=")
        );

        if (addressCookie) {
            addressCookie = JSON.parse(
                decodeURIComponent(addressCookie.split("=")[1])
            );
            setLocation(addressCookie);
            checkServiceAvailability(addressCookie);
        }
    }, []);

    useEffect(() => {
        setSortedServiceFeatures([
            ...new Set(
                availableServices
                    .map((el) => el.features.map((e) => e.key))
                    .flat()
            ),
        ]);
    }, [availableServices]);

    const closeApp = () => {
        window.location.href = "https://www.gtnet.hr/";
    };

    useEffect(() => {
        if (serviceType[0] === "Privatni") {
            setSelectedAttributes(JSON.parse(JSON.stringify(privateQuestions)));
        } else if (serviceType[0] === "Poslovni") {
            setSelectedAttributes(
                JSON.parse(JSON.stringify(bussinesQuestions))
            );
        } else {
            setSelectedAttributes(
                JSON.parse(JSON.stringify(seasonalQuestions))
            );
        }
    }, [serviceType]);

    const checkServiceAvailability = async (address = null) => {
        if (address || location) {
            setLoading(true);
            const result = await checkAvailability(address || location);
            setLoading(false);
            if (result) {
                if (result.length === 0) {
                    setError({
                        message:
                            "Trenutno nema dostupnih usluga za odabranu lokaciju.",
                        action: "Pokušajte drugu lokaciju",
                    });
                } else {
                    setProcessIndex("service_selection");
                }
            }
        }
    };

    const [inHelp, setInHelp] = useState({
        title: "",
        description: "",
        questions: [],
        active: false,
        quickTip: false,
    });

    /* Selected service */

    const [selectedService, setSelectedService] = useState();
    const [selectedTv, setSelectedTv] = useState(1);
    const [selectedPhone, setSelectedPhone] = useState(1);
    const [formSubmitted, setFormSubmitted] = useState();

    const resetData = () => {
        setError(initialState.error);
        setLoading(initialState.loading);
        setFormSent(initialState.formSent);
        setLocation(initialState.location);
        setServiceType(initialState.serviceType);
        setAdditionalOptions(initialState.additionalOptions);
        setSelectedService(initialState.selectedService);
        setSelectedTv(initialState.selectedTv);
        setSelectedPhone(initialState.selectedPhone);
        setFormSubmitted(initialState.formSubmitted);
        setSelectedAttributes(initialState.selectedAttibutes);
        setInHelp(initialState.inHelp);
        setIsOpen(false);
        setIsSatellite(initialState.isSatellite);
    };

    //
    const dataContext = {
        processIndex,
        setProcessIndex,
        formSent,
        setFormSent,
        loading,
        setLoading,
        error,
        setError,
        location,
        setLocation,
        availableServices,
        checkAvailability,
        serviceType,
        setServiceType,
        additionalOptions,
        setAdditionalOptions,
        selectedService,
        setSelectedService,
        selectedPhone,
        setSelectedPhone,
        selectedTv,
        setSelectedTv,
        formSubmitted,
        setFormSubmitted,
        resetData,
        selectedAttributes,
        setSelectedAttributes,
        inHelp,
        setInHelp,
        isOpen,
        setIsOpen,
        closeApp,
        sortedServiceFeatures,
        setSortedServiceFeatures,
        isSatellite,
        setIsSatellite,
        triggerInputHouseNumber,
        setTriggerInputHouseNumber,
        checkServiceAvailability,
    };

    return (
        <DataContext.Provider value={dataContext}>
            {children}
        </DataContext.Provider>
    );
};

export default DataProvider;
